import _ from 'lodash';
import nsApi from '@netsapiens/netsapiens-js/dist/api';

export default ({
  user,
  domain,
  limit,
  offset,
  id,
  instanceId,
  groupByInstance,
  getStart,
}) => {
  const params = {
    user,
    domain,
    object: 'meeting',
    action: 'readEvents',
    format: 'json',
    group_by_instance: groupByInstance || 1,
    limit: limit || 10,
    offset: offset || 0,
  };

  if (id) {
    params.meeting_id = id;
  }

  if (instanceId) {
    params.instance_id = instanceId;
  }

  if (getStart) {
    params.get_start = getStart;
  }

  return nsApi.get(params).then((res) => {
    if (typeof res.meeting_events !== 'undefined') {
      return res.meeting_events;
    }

    return res.map((meeting) => {
      const parsedMeeting = meeting;

      if (_.isString(parsedMeeting.attendees)) {
        parsedMeeting.attendees = JSON.parse(parsedMeeting.attendees);
      }

      return parsedMeeting;
    });
  }).catch(() => []);
};
